<span *ngFor="let crumb of breadcrumbs">
  <span
      *ngIf="crumb.name.toLowerCase() !== 'home'"
      class="angle-bracket"
  > > </span>
  <a
      routerLink="{{crumb.route}}"
  >{{crumb.name.toUpperCase()}}</a>
</span>
